require("jquery-match-height");

$(document).ready(function () {
  $(".bikmo-quote-block__card__text").matchHeight();
  $(".bikmo-quote-block__card__cost").matchHeight();
  $(".bikmo-quote-block__card__select-cover").matchHeight();
});
